// @flow
import React from "react";
import { classNames } from "../../lib/Util";

import "../../styles/react/editable_text_area.scss";

type Props = {
    value: string,
    title: string,
    isDisabled: boolean,
    placeholder?: string,
    size?: "small" | "normal",
    onChange: (value: string) => void,
    onBlur?: (value: string) => void,
};

type State = {};

export default class EditableTextArea extends React.Component<Props, State> {
    onChange = (event: SyntheticEvent<HTMLTextAreaElement>) => {
        const content = event.currentTarget.value;
        this.props.onChange(content);
    };

    onClick = (event: SyntheticEvent<HTMLTextAreaElement>) => {
        event.stopPropagation();
    };

    onBlur = (event: SyntheticEvent<HTMLTextAreaElement>) => {
        const content = event.currentTarget.value;
        if (this.props.onBlur) {
            this.props.onBlur(content);
        }
    };

    render() {
        return (
            <div
                className={classNames("editable-text-area", {
                    "editable-text-area--small": this.props.size === "small",
                })}
            >
                <textarea
                    disabled={this.props.isDisabled ? true : undefined}
                    className="form-control"
                    value={this.props.value}
                    placeholder={this.props.placeholder || ""}
                    onChange={this.onChange}
                    onClick={this.onClick}
                    onBlur={this.onBlur}
                    title={this.props.title}
                />
            </div>
        );
    }
}
